<!--suppress ALL -->
<template>
  <div class="py-4 bg-secondary">
    <div class="profile-page">
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{ $t('menu.main') }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ $t('menu.savoljavob') }}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <button class="button_sorov add-to-cart" @click="SavolDialog = true"><i class="el-icon-question"></i>
        {{ $t('menu.sendAnswer') }}
      </button>
    </div>
    <section class="section py-3">
      <div class="container">
        <div>
          <div class="tab_div_top">
            <el-row :gutter="15">
              <el-col :sm="24" :md="24" :lg="24" class="mb-2 mb-lg-10" v-for="item in answerAndQuestion">
                <div class="card card-lift shadow border-1 card_xalqaro">
                  <router-link :to="`/savol-javob-view/${item.id}`" style="color: #002060;">
                    <img src="img/icons/savol_javob.png" class="image_savol">
                    <div class="vertical-center" style="margin-left: 85px;">
                      <span class="card_span_xalqaro">{{ item.question }}</span>
                      <br>
                      <strong> #{{item.messageType}} ({{ moment(item.createdDate).format('DD.MM.YYYY') }})</strong>
                    </div>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div style="display: flex; justify-content: center; align-items: center; margin-top: 12px">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="20"
              background
              layout="total, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </section>
    <el-dialog
        :title="$t('menu.sendAnswer')"
        :visible.sync="SavolDialog"
        width="30%">
      <div>
        <el-input
            type="text"
            clearable
            placeholder="Исмингизни киритинг"
            size="small"
            :style="senderName === '' ? '' : 'margin-bottom: 10px;'"
            v-model="senderName">
        </el-input>
        <p v-if="senderName === ''" style="font-size: 12px; margin-bottom: 10px; color: red">Исм киритиш мажбурий!</p>
        <el-input
            type="textarea"
            :rows="2"
            autosize
            placeholder="Саволингизни киритинг"
            v-model="question">
        </el-input>
        <p v-if="question === ''" style="font-size: 12px; margin-bottom: 10px; color: red">Савол киритиш мажбурий!</p>
        <el-select  placeholder="Савол турини танланг" style="width: 100%; margin-top: 10px" v-model="tematika" size="small" clearable>
          <el-option
              v-for="item in blogsCases"
              :key="item.sortOrder"
              :label="$i18n.locale === 'ru-RU' ? item.titleRu : $i18n.locale === 'uz-UZ' ? item.titleUz : item.titleUzCyr"
              :value="$i18n.locale === 'ru-RU' ? item.titleRu : $i18n.locale === 'uz-UZ' ? item.titleUz : item.titleUzCyr">
          </el-option>
        </el-select>
        <p v-if="tematika === ''" style="font-size: 12px; color: red">Савол турини киритиш мажбурий!</p>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="SavolDialog = false" size="small">Bekor qilish</el-button>
    <el-button type="primary" @click="postQuestion" size="small">Yuborish</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  data() {
    return {
      activeName: 'savol_javob',
      SavolDialog: false,
      senderName: '',
      answerAndQuestion: [],
      currentPage: 0,
      total: 0,
      question: '',
      blogsCases: [],
      tematika: ''
    }
  },
  methods: {
    postQuestion() {
    if (this.senderName !== '' && this.tematika !== '' && this.question !== '') {
      axios.post(`https://www.prokuratura.uz/api/blogs-for-web-site/create`, {
        question: this.question,
        senderName: this.senderName,
        messageType: this.tematika,
        answer: null,
        isActive: false,
        createdDate: Date.now()
      })
          .then(response => {
            this.SavolDialog = false
            this.senderName = '',
            this.question = '',
            this.tematika = ''

            this.$message({
              message: 'Саволингиз қабул қилинди',
              type: 'success'
            });
          })
          .catch(error => {
            this.$message({
              message: 'Саволингиз қабул қилинмади',
              type: 'error'
            });
          })
    }
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      axios.get(`https://www.prokuratura.uz/api/blogs-for-web-site/list?page=${this.currentPage - 1}`)
          .then(response => {
            this.answerAndQuestion = response.data.content
            this.total = response.data.totalElements
          })
    }
  },
  mounted() {
    this.getData()
    axios.get(`https://www.prokuratura.uz/api/blogs-case-for-web-page/list`)
        .then(response => {
          this.blogsCases = response.data
        })

  }
};
</script>
<style scoped>



.bg-defaultnew {
  background: #fff;
  cursor: pointer;
}

.image_savol {
  /*width: 72px;*/
  height: 72px;
  border-right: 1px solid;
  padding-right: 5px;
}

.tab_div_top {
  min-height: 600px;
  margin-top: 15px;
}

.textnew-title_color {
  color: #394869;
}

.button_sorov {
  background-color: #394869;
  border: none;
  margin-left: -155px;
  cursor: pointer;
  position: absolute;
  transition: background-color 0.5s linear, color 0.5s linear;
}

.button_sorov:hover {
  background-color: #394869;
}

.button_sorov:focus {
  outline: none;
}

.add-to-cart {
  -webkit-animation: shadowFloat 1.2s linear alternate infinite;
  animation: shadowFloat 1.2s linear alternate infinite;
  border-radius: 50px;
  color: #fff;
  z-index: 100;
  /*font-size: 30px;*/
  /*padding: 0px 7px;*/
  font-size: 16px;
  padding: 4px 12px;
  text-transform: uppercase;
  text-shadow: 0 1px 1px #394869;
}

@-webkit-keyframes shadowFloat {
  0% {
    box-shadow: 0 20px 40px #c7c7c7;
    transform: translateY(-3px);
  }
  100% {
    box-shadow: 0 10px 10px #bababa;
    transform: translateY(3px);
  }
}

@keyframes shadowFloat {
  0% {
    box-shadow: 0 20px 40px #c7c7c7;
    transform: translateY(-3px);
  }
  100% {
    box-shadow: 0 10px 10px #bababa;
    transform: translateY(3px);
  }
}
</style>
